export default __webpack_public_path__ + "static/media/darkProfileIcon.a8bc4ef8.svg";